<!-- <app-search-events [isLive]="true"></app-search-events> -->
<div class="events-live-wrap" (click)="$event.stopPropagation();" *ngIf="eventsAndSelections">
    <div class="sport-tree" *ngIf="orderBySport; else all">

        <ul class="list">
            <ng-container *ngFor="let eventsAndSelection of eventsAndSelections; let i = index">
                <li *ngIf="eventsAndSelection.eventsCount>0">
                    <div *ngIf="eventsAndSelection.eventsCount>0" class="sport-info" (click)="expand(eventsAndSelection);">
                        <div class="name-wrap">
                            <div class="icon-wrap">
                                <i class="icon-sm m-r s-icon-{{getSportName(eventsAndSelection.sportId)}} sportid-{{eventsAndSelection.sportId}}"></i>
                            </div>
                            <span class="name">{{eventsAndSelection.sportName}}</span>
                        </div>
                        <div class="events-count">
                            {{eventsAndSelection.eventsCount}}
                            <span class="arrow-down icon icon-xs icon-chevron-down" [class.open]="eventsAndSelection.isExpanded"></span>
                        </div>
                    </div>


                    <ul class="sub-list region-list" [class.hide]="!eventsAndSelection.isExpanded">
                        <li class="live" *ngFor="let eventList of eventsAndSelection.eventsLists; let i = index">

                            <div class="competition-info" *ngIf="i==0 || eventsAndSelection.eventsLists[i-1].competitionId != eventList.competitionId">
                                <span class="region-name">{{eventList.regionName}} - {{eventList.competitionName}}</span>
                            </div>
                            <section class="events-main-wrap">
                                <ng-container *ngTemplateOutlet="eventsTemplate; context:{eventsAndSelection: eventsAndSelection, eventList: eventList}"></ng-container>
                            </section>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </ul>
    </div>

    <ng-template #all>
        <section class="events-main-wrap all-event">
            <ng-container *ngFor="let eventsAndSelection of eventsAndSelections; let i = index">
                <ng-container *ngFor="let eventList of eventsAndSelection.eventsLists; let i = index">
                    <ng-container *ngTemplateOutlet="eventsTemplate; context:{eventsAndSelection: eventsAndSelection, eventList: eventList}"></ng-container>
                </ng-container>

            </ng-container>

        </section>

    </ng-template>


</div>


<ng-template #eventsTemplate let-eventsAndSelection="eventsAndSelection" let-eventList="eventList">
  <ng-container *ngIf="orderBySport || eventsAndSelection.sportId != -99">
    <div class="event-wrap" (click)="showDetail(event);" [class.expanded]="event.isExpanded" *ngFor="let event of eventList.events; let j = index">
        <div class="slider" [class.sport]="orderBySport">
            <div class="row event-info">
                <i *ngIf="!orderBySport" class="icon-ex-sm s-icon-{{getSportName(event.sportId)}} sportid-{{event.sportId}}"></i>
                <!-- <div class="sport-icon" >
                    <app-svg-icon iconId="{{event.sportId}}"></app-svg-icon>
                </div> -->
                <div class="name-result-wrap">
                    <div class="name swipe-event">
                        <ng-container *ngIf="event.homeTeam != null || event.awayTeam !==null; else outright;">
                            <div class="team-name">
                                <span class="server" *ngIf="event.result?.server == 1"></span>
                                <span class="red-card" *ngIf="event?.result?.homeRedCards">
                                    <ng-container *ngIf="event.result.homeRedCards > 1">{{event.result.homeRedCards}}</ng-container>
                                </span>
                                {{event.homeTeam}}
                            </div>
                            -
                            <div class="team-name">
                                <span class="server" *ngIf="event.result?.server == 2"></span>
                                <span class="red-card" *ngIf="event?.result?.awayRedCards">
                                    <ng-container *ngIf="event.result.awayRedCards > 1">{{event.result.awayRedCards}}</ng-container>
                                </span>
                                {{event.awayTeam}}
                            </div>
                        </ng-container>
                        <ng-template #outright>
                            <span>{{event.eventName}}</span>
                        </ng-template>

                    </div>
                    <div class="result-wrap" *ngIf="event.result">
                        <span class="result">{{event.result.score}}</span>
                        <span class="time">{{event.result.status}} {{event.result.matchTime}} </span>
                    </div>
                </div>
                <div class="favorite" (click)="toggleFavorites(event);  $event.stopPropagation();" >
                    <i class="sporticon icon-xs sporticon-{{event.isInFavorite ? 'star' : 'star-border'}}"></i>
                </div>
            </div>

            <article class="row">
                <div class="bet-type-wrap">
                    <ng-container *ngIf="eventsAndSelection.selections[0] || eventsAndSelection.firstSelectionBySport[event.sportId]; let selection">
                        <ng-container *ngIf="event.isPlayable && betsAndOutcomesForEvents[event.id] && betsAndOutcomesForEvents[event.id].bets[selection.betTypeId] && betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].isPlayable else emptyBet">
                            <div class="bet-type-col">
                                <ng-container *ngFor="let betTypeOutcome of selection.betTypeOutcomes; let i = index;">
                                    <ng-container *ngIf="betsAndOutcomesForEvents[event.id].betOutcomes[betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].id]
                                    && betsAndOutcomesForEvents[event.id].betOutcomes[betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].id][betTypeOutcome.id] && betsAndOutcomesForEvents[event.id].betOutcomes[betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].id][betTypeOutcome.id][0]; let betOutcome; else emptyOutcome">
                                      <ng-container *ngIf="betOutcome.isPlayable; else emptyOutcome">
                                        <div class="outcome-wrap" [@blink-border]="betOutcome.odd" [ngClass]="{'selected': betOutcome.isSelected}"
                                        (click)="toggleEventOutcome(event, betsAndOutcomesForEvents[event.id].bets[selection.betTypeId], betOutcome, betTypeOutcome.name, selection.betTypeName); $event.stopPropagation(); ">
                                            <span class="outcome-name">{{betTypeOutcome.name}}</span>
                                            <span class="outcome-odd">
                                                {{betOutcome.odd | odd}}
                                            </span>
                                        </div>
                                      </ng-container>
                                    </ng-container>
                                    <ng-template #emptyOutcome>
                                        <div class="outcome-wrap" (click)="$event.stopPropagation();">
                                            <span class="outcome-name">{{betTypeOutcome.name}}</span>
                                            <span class="outcome-odd locked">
                                                <app-svg-icon iconId="lock"></app-svg-icon>
                                            </span>
                                        </div>

                                    </ng-template>
                                    <div class="result-wrap" *ngIf="i==0 && selection.betTypeOutcomes.length < 3 && event.result && event.result.setScore">
                                        <div class="current-gem" *ngIf="event.result.homeGameScore">{{event.result.homeGameScore}}</div>
                                        <div class="set-score-wrap">
                                            <div class="set-score">
                                                <span *ngFor="let homeSetScore of event.result.homeSetScore">{{homeSetScore}}</span>
                                            </div>
                                            <div class="set-score">
                                                <span *ngFor="let awaySetScore of event.result.awaySetScore">{{awaySetScore}}</span>
                                            </div>
                                        </div>
                                        <div class="current-gem" *ngIf="event.result.awayGameScore">{{event.result.awayGameScore}}</div>

                                    </div>

                                    <span class="sbv" *ngIf="i==0 && selection.hasSBV">
                                      <ng-container *ngIf="!betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].useSbvHandicapPipe">{{betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].sbv}}</ng-container>
                                      <ng-container *ngIf="betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].useSbvHandicapPipe">{{betsAndOutcomesForEvents[event.id].bets[selection.betTypeId].sbv | handicapSbv}}</ng-container>
                                    </span>
                                </ng-container>

                            </div>

                        </ng-container>

                        <ng-template #emptyBet>

                            <div class="bet-type-col" >
                                <ng-container *ngFor="let i of arr(selection.betTypeOutcomes.length); let j = index">
                                  <div class="outcome-wrap" (click)="$event.stopPropagation();">
                                    <span class="outcome-odd locked disabled offline">
                                      <app-svg-icon iconId="lock"></app-svg-icon>
                                    </span>
                                  </div>

                                  <div class="result-wrap"
                                    *ngIf="j==0 && selection.betTypeOutcomes.length < 3 && event.result && event.result.setScore">
                                    <div class="current-gem" *ngIf="event.result.homeGameScore">{{event.result.homeGameScore}}</div>
                                    <div class="set-score-wrap">
                                      <div class="set-score">
                                        <span *ngFor="let homeSetScore of event.result.homeSetScore">{{homeSetScore}}</span>
                                      </div>
                                      <div class="set-score">
                                        <span *ngFor="let awaySetScore of event.result.awaySetScore">{{awaySetScore}}</span>
                                      </div>
                                    </div>
                                    <div class="current-gem" *ngIf="event.result.awayGameScore">{{event.result.awayGameScore}}</div>

                                  </div>
                                    <span class="sbv" *ngIf="j==0 && selection.hasSBV">-</span>
                                </ng-container>
                            </div>
                        </ng-template>



                    </ng-container>

                </div>

                <div class="expand-event live" [class.disabled]="!event.isPlayable" >+{{event.betsCount}}</div>

            </article>

        </div>

        <div class="slide-button" (click)="toggleFavorites(event); $event.stopPropagation(); ">
            <i class="sporticon icon-sm sporticon-{{event.isInFavorite ? 'star' : 'star-border'}}"></i>
        </div>

        <div class="slide-button stat" *ngIf="event.betRadarEventId" (click)="headToHeadWidget(event.betRadarEventId); $event.stopPropagation();">
            <span class="sporticon icon-sm sporticon-chart"></span>
        </div>

    </div>
  </ng-container>
</ng-template>

<!-- <app-event-live-detail-mobile *ngIf="expandedEvent" [expandedEvent]="expandedEvent"></app-event-live-detail-mobile> -->
